module.exports = __webpack_public_path__ + "media/images/custom-grouping-6aa6a75769ec2c0db11f8a85b0095461.png";